(function () {
  function initBannerCarousel(carousel) {
    if (!carousel || carousel.dataset.initialized === 'true') return;

    const slides = Array.from(carousel.querySelectorAll('[data-banner-slide]'));
    const dots = Array.from(carousel.querySelectorAll('[data-banner-dot]'));
    const prevButton = carousel.querySelector('[data-banner-prev]');
    const nextButton = carousel.querySelector('[data-banner-next]');
    const touchTarget = carousel.closest('.banner') || carousel;
    const autoplayEnabled = carousel.dataset.autoplay === 'true';
    const autoplaySpeed = Number(carousel.dataset.speed || 5000);

    if (slides.length <= 1) {
      carousel.dataset.initialized = 'true';
      return;
    }

    let activeIndex = slides.findIndex((slide) => slide.classList.contains('is-active'));
    let autoplayTimer = null;
    let touchStartX = 0;
    let touchDeltaX = 0;

    if (activeIndex < 0) activeIndex = 0;

    function updateSlides(nextIndex) {
      activeIndex = (nextIndex + slides.length) % slides.length;

      slides.forEach((slide, index) => {
        const isActive = index === activeIndex;
        slide.classList.toggle('is-active', isActive);
        slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
      });

      dots.forEach((dot, index) => {
        const isActive = index === activeIndex;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });
    }

    function goTo(index) {
      updateSlides(index);
      restartAutoplay();
    }

    function goNext() {
      updateSlides(activeIndex + 1);
    }

    function goPrev() {
      updateSlides(activeIndex - 1);
    }

    function pauseAutoplay() {
      if (!autoplayTimer) return;
      window.clearInterval(autoplayTimer);
      autoplayTimer = null;
    }

    function startAutoplay() {
      if (!autoplayEnabled) return;
      pauseAutoplay();
      autoplayTimer = window.setInterval(goNext, autoplaySpeed);
    }

    function restartAutoplay() {
      if (!autoplayEnabled) return;
      startAutoplay();
    }

    prevButton?.addEventListener('click', function () {
      goPrev();
      restartAutoplay();
    });

    nextButton?.addEventListener('click', function () {
      goNext();
      restartAutoplay();
    });

    dots.forEach((dot) => {
      dot.addEventListener('click', function () {
        goTo(Number(dot.dataset.slideIndex));
      });
    });

    carousel.addEventListener('mouseenter', pauseAutoplay);
    carousel.addEventListener('mouseleave', startAutoplay);
    carousel.addEventListener('focusin', pauseAutoplay);
    carousel.addEventListener('focusout', startAutoplay);

    touchTarget.addEventListener(
      'touchstart',
      function (event) {
        if (event.target.closest('a, button')) return;
        touchStartX = event.changedTouches[0].clientX;
        touchDeltaX = 0;
        pauseAutoplay();
      },
      { passive: true }
    );

    touchTarget.addEventListener(
      'touchmove',
      function (event) {
        if (event.target.closest('a, button')) return;
        touchDeltaX = event.changedTouches[0].clientX - touchStartX;
      },
      { passive: true }
    );

    touchTarget.addEventListener(
      'touchend',
      function (event) {
        if (event.target.closest('a, button')) return;
        if (Math.abs(touchDeltaX) > 40) {
          if (touchDeltaX < 0) {
            goNext();
          } else {
            goPrev();
          }
        }

        startAutoplay();
      },
      { passive: true }
    );

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        pauseAutoplay();
      } else {
        startAutoplay();
      }
    });

    updateSlides(activeIndex);
    startAutoplay();
    carousel.dataset.initialized = 'true';
  }

  function initAllBannerCarousels(container) {
    const scope = container || document;
    scope.querySelectorAll('[data-banner-carousel]').forEach(initBannerCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAllBannerCarousels(document);
    });
  } else {
    initAllBannerCarousels(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAllBannerCarousels(event.target);
  });
})();
